const { buildErrResponse } = require("../_utils/utils");
const { BASE_URL, BASE_URL_DEV } = require("../_constants/urlConstants");
const { default: Axios } = require("axios");

export const ProductService = {
  getAllProducts,
  getAllProductsInRange,
  getAllProductsInRangeByType,
  getProductById,
  getProductByAccesories,
  getProductByMoviles,
  getProductMovilesWithAvailability,
  getProductByMovilesWithParams,
  getProductMovile,
  getProductByAccesoriesWithParams,
  getProductAccesoriesWithAvailability,
  getProductByChips,
  getProductByChipsWithParams,
  getProductByCashCard,
  getProductByCashCardWithParams,
  getProductByBalanceTranferWithParams,

  countMovilesInStore,
  countMovilesInSites,
  countMovilesInSingleSite,
  countAccesoriesSingleSite,
  countAccesoriesInSites,
  countAccesoriesInStore,
  countChipsInStore,
  countChipsInSites,
  countChipsSingleSite,
  countCashCardsInStore,
  countCashCardsInSite,
  countCashCardsInSingleSite,

  getAccesoryProduct,
  getAccesoryProductByBarCode,
  getAccesoryProductByParams,
  getMovileProductByImei,
  getProductsByMovilebarCode,
  updateBulkProductFactureCreated,
  postProduct,
  deleteProduct,
};

function getAllProducts() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllProductsInRange(body) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/product/in-range`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllProductsInRangeByType(body) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/product/in-range-by-type`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getProductById(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/byId?id=${id}`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getProductByAccesories() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/all-accesories`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getProductByMoviles() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/all-moviles`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getProductMovilesWithAvailability(queryParams) {
  const { brand, model, color, barCode, siteId, inDistribution, productSold } =
    queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/all-moviles-site-availabilty`, {
      params: {
        brand,
        model,
        color,
        barCode,
        siteId,
        inDistribution,
        productSold,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getProductByMovilesWithParams(queryParams) {
  const { brand, model, color, siteId, inDistribution, barCode, productSold } =
    queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/all-moviles`, {
      params: {
        brand,
        model,
        color,
        siteId,
        inDistribution,
        barCode,
        productSold,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getProductByChipsWithParams(queryParams) {
  const { chipCatalogueId, siteId, lote, inDistribution, iccid, productSold } =
    queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/all-chips`, {
      params: {
        chipCatalogueId,
        siteId,
        lote,
        inDistribution,
        iccid,
        productSold,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
function getProductByCashCard() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/all-cash-card`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
function getProductByCashCardWithParams(queryParams) {
  const { siteId, inDistribution, cardCatalogueId, productSold } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/all-cash-card`, {
      params: {
        cardCatalogueId,
        siteId,
        inDistribution,
        productSold,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
function getProductByBalanceTranferWithParams(queryParams) {
  const { siteId, paymentPending, balanceCatalogueId } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/all-balance-transfer`, {
      params: {
        siteId,
        paymentPending,
        balanceCatalogueId,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getProductMovile(queryParams) {
  const { imeiCode, siteId, inDistribution } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/movile`, {
      params: {
        imeiCode,
        siteId,
        inDistribution,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

/** AccesoryInventoryBySite */
function getProductByAccesoriesWithParams(queryParams) {
  const {
    brand,
    model,
    color,
    barCode,
    siteId,
    inDistribution,
    productSold,
    subcategoryTypeId,
  } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/all-accesories`, {
      params: {
        brand,
        model,
        color,
        barCode,
        siteId,
        inDistribution,
        productSold,
        subcategoryTypeId,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

/** Service for build excel */
function getProductAccesoriesWithAvailability(queryParams) {
  const { siteId, inDistribution } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/all-accesories-site-availabilty`, {
      params: {
        siteId,
        inDistribution,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getProductByChips() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/all-chips`, {})
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function countMovilesInStore(params) {
  const { brand, model, barCode } = params;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/count-moviles-inStore`, {
      params: {
        brand,
        model,
        barCode,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function countMovilesInSites(params) {
  const { brand, model, barCode } = params;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/count-moviles-inSite`, {
      params: {
        brand,
        model,
        // color,
        barCode,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function countMovilesInSingleSite(queryParams) {
  const { brand, model, siteId, inDistribution, productSold, barCode } =
    queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/count-moviles-singleSite`, {
      params: {
        brand,
        model,
        siteId,
        inDistribution,
        productSold,
        barCode,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function countAccesoriesSingleSite(queryParams) {
  const {
    brand,
    model,
    siteId,
    subcategoryTypeId,
    barCode,
    inDistribution,
    productSold,
  } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/count-accesories-singleSite`, {
      params: {
        brand,
        model,
        siteId,
        barCode,
        inDistribution,
        productSold,
        subcategoryTypeId,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        console.log("error here", err.response);
        reject(buildErrResponse(err));
      });
  });
}

function countAccesoriesInSites(params) {
  const { brand, model, barCode } = params;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/count-accesories-inSite`, {
      params: {
        brand,
        model,
        barCode,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function countAccesoriesInStore(params) {
  const { brand, model, barCode } = params;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/count-accesories-inStore`, {
      params: {
        brand,
        model,
        barCode,
        // color,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function countChipsInStore(body) {
  const { lote, inDistribution, chipCatalogueId } = body;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/count-chips-inStore`, {
      params: {
        lote,
        inDistribution,
        chipCatalogueId,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function countChipsInSites(body) {
  const { lote, inDistribution, chipCatalogueId } = body;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/count-chips-inSite`, {
      params: {
        lote,
        inDistribution,
        chipCatalogueId,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function countChipsSingleSite(queryParams) {
  const { lote, inDistribution, siteId, chipCatalogueId, productSold } =
    queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/count-chips-singleSite`, {
      params: {
        lote,
        inDistribution,
        siteId,
        chipCatalogueId,
        productSold,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function countCashCardsInStore(queryParams) {
  const { inDistribution, cardCatalogueId, productSold } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/count-cash-card-inStore`, {
      params: {
        inDistribution,
        cardCatalogueId,
        productSold,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function countCashCardsInSite(queryParams) {
  const { inDistribution, cardCatalogueId } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/count-cash-card-inSite`, {
      params: {
        inDistribution,
        cardCatalogueId,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function countCashCardsInSingleSite(queryParams) {
  const { siteId, cardCatalogueId, inDistribution, productSold } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/count-cash-card-singleSite`, {
      params: {
        siteId,
        cardCatalogueId,
        inDistribution,
        productSold,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAccesoryProduct(body) {
  return new Promise((resolve, reject) => {
    Axios.get(
      `${BASE_URL_DEV}/product/accesories?brand=${body.brand}&model=${body.model}`
    )
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAccesoryProductByBarCode(barCode) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/accesories/bybarCode?barCode=${barCode}`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAccesoryProductByParams(queryParams) {
  const { barCode, siteId, productSold, inDistribution } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/accesories`, {
      params: {
        barCode,
        siteId,
        productSold,
        inDistribution,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getMovileProductByImei(imei) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/movile/by-imei?imei=${imei}`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getProductsByMovilebarCode(barCode) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/product/moviles/bybarCode?barCode=${barCode}`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateBulkProductFactureCreated(idProducts) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/product/bulk/receipt-created`, idProducts)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function postProduct(body) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/product`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function deleteProduct(productId) {
  return new Promise((resolve, reject) => {
    Axios.delete(`${BASE_URL_DEV}/product?id=${productId}`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
